import React, { useEffect, useState } from 'react';
import { formatDateToLima } from '../../utils/dateUtils';

const addDaysYmd = (ymd, days) => {
  const [year, month, day] = String(ymd).split('-').map(Number);
  const date = new Date(year, month - 1, day + days, 12, 0, 0, 0);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const VentasCreateShiftModal = ({
  isOpen,
  pointOfSale,
  closedShiftDates = [],
  onClose,
  onConfirm,
}) => {
  const todayKey = formatDateToLima(new Date());
  const suggestedDate = closedShiftDates.includes(todayKey) ? addDaysYmd(todayKey, 1) : todayKey;
  const [shiftDate, setShiftDate] = useState(suggestedDate);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setError('');
      return;
    }
    setShiftDate(suggestedDate);
    setError('');
  }, [isOpen, suggestedDate]);

  if (!isOpen) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!shiftDate) {
      setError('Seleccione la fecha de los documentos');
      return;
    }
    if (closedShiftDates.includes(shiftDate)) {
      setError('Ese día ya tiene el turno cerrado. No se pueden crear documentos en una fecha cerrada.');
      return;
    }
    onConfirm({ shift_date: shiftDate });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <form onSubmit={handleSubmit}>
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">Crear documentos</h2>
            <p className="text-sm text-gray-600 mt-1">
              {pointOfSale?.name
                ? `${pointOfSale.code ? `${pointOfSale.code} — ` : ''}${pointOfSale.name}`
                : 'Seleccione la fecha de los documentos'}
            </p>
          </div>

          <div className="px-6 py-4 space-y-4">
            <p className="text-sm text-gray-600">
              Indique el día de los documentos. Si esa fecha ya está cerrada, no podrá continuar. Si está
              disponible, se abrirá el formulario de venta con esa fecha.
            </p>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Fecha <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={shiftDate}
                onChange={(e) => {
                  setShiftDate(e.target.value);
                  setError('');
                }}
                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                  error ? 'border-red-300' : 'border-gray-300'
                }`}
                required
              />
              {error ? <p className="mt-1 text-sm text-red-600">{error}</p> : null}
              {shiftDate && closedShiftDates.includes(shiftDate) ? (
                <p className="mt-1 text-sm text-amber-700">
                  Esta fecha ya tiene turno cerrado. Elija otra o use «Abrir turno» en ese día.
                </p>
              ) : null}
            </div>
          </div>

          <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!shiftDate || closedShiftDates.includes(shiftDate)}
              className="px-4 py-2 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-md disabled:opacity-60"
            >
              Continuar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VentasCreateShiftModal;
